import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { MathHelper } from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import { TimelineMax, Power3, TweenLite, TimelineLite, Power0, Back } from "gsap";
import { SanGameConfig } from "../../../SanGameConfig";
import { SanEngineManager } from "../../../engine/SanEngineManager";
import { SanSymbolData } from "../../../engine/Symbol/SanSymbolData";
import { GameResources } from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import { BaseView } from "@nolimitcity/slot-game/bin/core/base/BaseView";
import { Sequence } from "@nolimitcity/slot-game/bin/core/displayobject/Sequence";
import { ArrayHelper } from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";
import { RevealerBar } from "./RevealerBar";
import { SanSpriteSymbol } from "../../../engine/Symbol/SanSpriteSymbol";
import { ReelSymbolName } from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import { SymbolMultiplyCounter } from "../symbol/SymbolMultiplyCounter";
import { StateHandler } from "@nolimitcity/slot-game/bin/core/utils/StateHandler";
import { BLEND_MODES } from "pixi.js";
import { ReelSymbolStates } from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/ReelSpriteSymbolArea";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { PayTableEvent } from "../../../engine/Symbol/MiniPayTable";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import { TextStyleConfig } from "../../../translation/TextStyleConfig";
import { MultSequence } from "../../../proto/MultSequence";
import { SoundConfig } from "../../../SoundConfig";
import { SoundManager } from "../../../resource/sound/SoundManager";
import {SanQuentin} from "../../../SanQuentin";
import { ReelOverlay } from "../../background/ReelOverlay";

export class ReavealerState extends StateHandler {
    public static readonly NORMAL: string = "normal";
    public static readonly EXPANDING: string = "expandig";
    public static readonly MULTIPLIER: string = "multiplier";
    public static readonly EXTRA_FS: string = "extra_fs";
}

class RevealSpinner extends PIXI.Container{

    private shuffleArray: string[] = [
        "M1/2/M1_spin",
        "M2/2/M2_spin",
        "M3/2/M3_spin",
        "M4/2/M4_spin",
        "M5/2/M5_spin",
        "M2/2/M2_spin",
        "M3/2/M3_spin",
        "M4/2/M4_spin",
        "M5/2/M5_spin",
        "M2/2/M2_spin",
        "M3/2/M3_spin",
        "M4/2/M4_spin",
        "M5/2/M5_spin",
        "M2/2/M2_spin",
        "M3/2/M3_spin",
        "M4/2/M4_spin",
        "M5/2/M5_spin",
        "Splitter/Splitter_spin",
    ];

    private shuffleArrayText: string[] = [
        "+1",
        "+2",
        "+3"
    ];

    public shuffleArray_Res: string[] = ["X2"];
    public shuffleSym_Res: string[] = [
        "M1/2/M1_normal",
        "M2/2/M2_normal",
        "M3/2/M3_normal",
        "M4/2/M4_normal",
        "M5/2/M5_normal",
        "Splitter/Splitter_normal",
    ];

    private shuffleTime: number = 0.08;
    private shuffleAlpha: number = 0.40;

    private fsMultFrame:PIXI.Sprite;

    private seq_res:PIXI.Sprite;
    private seq_filler:PIXI.Sprite;

    private item_text_res: PIXI.Text;
    private item_text_filler: PIXI.Text;

    private shuffle_tl:TimelineMax;
    private expand_tl:TimelineMax;

    private resText:string = "X";
    private resTexure:PIXI.Texture[];
    private maskCont:PIXI.Container;
    private maskElement:PIXI.Graphics;
    private loopIndex:number = 0;

    public isNormalMode:boolean = true;
    public playBounceSound:boolean = false;
    public playBounceSoundSlice:boolean = false;

    private _standardMultText:SymbolMultiplyCounter;

    public get shuffleTL():TimelineMax{
        return this.shuffle_tl;
    }

    constructor(){
        super();
        this.resTexure = GameResources.getTextures("M/2/M_normal");
        ArrayHelper.shuffle(this.shuffleArray);
        ArrayHelper.shuffle(this.shuffleArrayText);
        this.initItems();
    }

    private nextShuffleItem():PIXI.Texture{
        this.loopIndex++;
        return GameResources.getTextures(this.CurrentShuffleValue[this.loopIndex % this.CurrentShuffleValue.length])[0]
    }

    private nextShuffleText():string{
        this.loopIndex++;
        return (this.CurrentShuffleValue[this.loopIndex % this.CurrentShuffleValue.length]);
    }

    private get CurrentShuffleValue():string[]{
        return this.isNormalMode ? this.shuffleArray : this.shuffleArrayText;
    }

    private set CurrentShuffleValue(val:string[]){
        if(this.isNormalMode)
            this.shuffleArray = val;
        else
            this.shuffleArrayText = val;
    }

    private isFSMult:number;
    public setFSSymbol(val:number): void {
        this.isFSMult = val;
    };

    public get resSeq():PIXI.Sprite{
        return this.seq_res;
    }

   public hideSequenceAlpha(value:boolean):void{
        if(value===true){
            this.seq_filler.alpha=0;
            this.seq_res.alpha=0;
        }else{
            this.seq_filler.alpha=1;
            this.seq_res.alpha=1;
        }

   }
    public spinModeNormal(value:boolean):void{
        this.isNormalMode = value;

        this.seq_res.visible = value;
        this.seq_filler.visible = value;

        this.item_text_res.visible = !value;
        this.item_text_filler.visible = !value;
    }

    private initItems():void{
        const arrToMessWith:string[] =  this.shuffleSym_Res;
        const starySymPath:string = arrToMessWith[Math.floor(Math.random()*arrToMessWith.length)%arrToMessWith.length];

        this.maskCont = this.addChild(new PIXI.Container());
        this.seq_res = this.maskCont.addChild(this.createSprite(GameResources.getTextures(starySymPath)));
        this.seq_filler = this.maskCont.addChild(this.createSprite(GameResources.getTextures(starySymPath)));
        this.seq_filler.y = -this.halfSymHeight;

        this._standardMultText = this.maskCont.addChild(new SymbolMultiplyCounter());
        this._standardMultText.visible = false;
        this._standardMultText.zIndex = 200;
        this._standardMultText.x = 70;
        
        this.fsMultFrame = this.maskCont.addChild(this.createSprite(GameResources.getTextures("Sym_Frame_Multiplier_2")));
        this.fsMultFrame.alpha = 1;
        this.fsMultFrame.visible = false;
        this.fsMultFrame.zIndex = 100;

        this.item_text_res = this.maskCont.addChild(this.createTextObject());
        this.item_text_res.position = Helper.copyLocalPosition(this.item_text_res,this.seq_res);
        this.item_text_filler = this.maskCont.addChild(this.createTextObject());
        this.item_text_filler.position = Helper.copyLocalPosition(this.item_text_filler,this.seq_filler);

        this.spinModeNormal(true);
        if(!SanQuentin.api.gameClientConfiguration.showNearMissGfx) {
            this.hideSequenceAlpha(true);
        }

        this.maskElement = this.createGraphic();
        this.mask = this.maskElement;

        this.boostPerformance(true);

        this.sortChildren();
        this.maskCont.sortChildren();
    }

    private boostPerformance(val:boolean):void{
        this.maskElement.alpha = val ? 0 : 1;
        this.maskElement.visible = !val;
        this.mask = val ? null! : this.maskElement;
        this.fillerItem.alpha = val ? 0 : 1;
    }

    private createTextObject(): PIXI.Text {
        const textObj = new PIXI.Text("X", TextStyleConfig.BAR_REVEALER_TEXT);
        textObj.position.y = -SanSymbolData.DEFAULT_SYMBOL.DIM.HEIGHT * 0.25;
        textObj.anchor.set(0.5, 0.5);
        textObj.visible = false;
        return textObj;
    }

    private createSprite(texture: PIXI.Texture[]): PIXI.Sprite {
        const sp: PIXI.Sprite = new PIXI.Sprite(texture[0]); Sequence.createSequence(texture);
        sp.anchor.set(0.5,0.5);
        sp.visible = false;
        return sp;
    }

    private createGraphic():PIXI.Graphics{
        const graphicBg:PIXI.Graphics =  new PIXI.Graphics();

        const c:number = 0x000000;
        graphicBg.beginFill(c, 1);

        graphicBg.drawRect(-SanSymbolData.DEFAULT_SYMBOL.DIM.WIDTH*0.5, -(this.halfhalfSymHeight+2),
             SanSymbolData.DEFAULT_SYMBOL.DIM.WIDTH, this.halfSymHeight+2);

        graphicBg.endFill();
        this.addChild(graphicBg);
        return graphicBg;
    }

    public shuffle(active: boolean): TimelineMax {
        if (active) {
            
            const spinStartDurr:number = SanGameConfig.instance.REEL_ENGINE_CONFIG.DURATION.START;
            const ease:any =  SanEngineManager.isQuickStop ? SanGameConfig.instance.REEL_ENGINE_CONFIG.EASING.QUICK_START : SanGameConfig.instance.REEL_ENGINE_CONFIG.EASING.START; 
            this.CurrentShuffleValue = ArrayHelper.shuffle(this.CurrentShuffleValue);

            if(this.isNormalMode){
                this.fillerItem.texture = this.nextShuffleItem();
            }else{
                (<PIXI.Text>this.fillerItem).text = (this.nextShuffleText());
            }

            this.shuffle_tl = Helper.timeLineKiller(this.shuffle_tl, new TimelineMax({
                onStart:() => {
                    this.boostPerformance(false);
                },
                onComplete:() => {
                        this.createLoop(active)
                    }
                })
            );

            this.shuffle_tl.fromTo(this.maskCont.position,spinStartDurr,{y:0},{y:this.halfSymHeight,ease:ease},0)
            this.shuffle_tl.to(this,spinStartDurr/2,{alpha:this.shuffleAlpha},spinStartDurr/2)
            this.shuffle_tl.play();
        } else {
            this.createLoop(active);
        }
        return this.shuffle_tl;
    }

    private get halfSymHeight():number{
        return SanSymbolData.DEFAULT_SYMBOL.DIM.HEIGHT*0.5;
    }

    private get halfhalfSymHeight():number{
        return SanSymbolData.DEFAULT_SYMBOL.DIM.HEIGHT*0.25;
    }

    private get resItem():PIXI.Sprite | PIXI.Text {
        return this.isNormalMode ? this.seq_res : this.item_text_res;
    }

    private get fillerItem():PIXI.Sprite | PIXI.Text{
        return this.isNormalMode ? this.seq_filler : this.item_text_filler;
    }

    private createLoop(active: boolean):void{
        if (active) {
            this.hideSequenceAlpha(false);
            this.fsMultFrame.visible =  false;
            this._standardMultText.visible =  false;

            this.CurrentShuffleValue = ArrayHelper.shuffle(this.CurrentShuffleValue);
            this.fillerItem.alpha = 1;
            if(this.isNormalMode){
                this.resItem.texture = this.fillerItem.texture;
                this.fillerItem.texture = this.nextShuffleItem();
            }else{
                (<PIXI.Text>this.resItem).text = (<PIXI.Text>this.fillerItem).text;
                (<PIXI.Text>this.fillerItem).text = this.nextShuffleText();
            }    

            this.shuffle_tl = Helper.timeLineKiller(this.shuffle_tl, new TimelineMax(
                {
                    repeat: -1, repeatDelay: 0,
                    onRepeat: () => {   
                        if(this.isNormalMode){
                            this.resItem.texture = (this.fillerItem.texture);
                            this.fillerItem.texture = (this.nextShuffleItem())    
                        }else{
                            (<PIXI.Text>this.resItem).text = (<PIXI.Text>this.fillerItem).text;
                            (<PIXI.Text>this.fillerItem).text = (this.nextShuffleText())
                        }                   
                    }
            }));
            
            this.shuffle_tl.add(() => this.alpha = this.shuffleAlpha ,0)
            this.shuffle_tl.fromTo(this.maskCont.position,this.shuffleTime,{y:0},{y:this.halfSymHeight,ease:Power0.easeNone},0)
            this.shuffle_tl.play();
        } else {
            this.fillerItem.alpha = 1;
            this.shuffle_tl = Helper.timeLineKiller(this.shuffle_tl, new TimelineMax({
                onComplete: () => {
                    this.fsMultFrame.y = 0;
                    this._standardMultText.y = 25;
                    this.maskCont.position.y = 0;
                    if(this.isNormalMode){
                        this.resItem.texture = (this.resTexure[0]);
                    }
                    else{
                        TweenLite.to(this,0.25,{alpha:this.shuffleAlpha,delay:0.3});
                        (<PIXI.Text>this.resItem).text = this.resText;
                    }
                    
                    this.boostPerformance(true);
                }                        
            }));

            if(this.isFSMult){
                this._standardMultText.y = -this.halfSymHeight + 25;
                this.fsMultFrame.y = -this.halfSymHeight;
                this._standardMultText.apply(this.isFSMult);
            }
            if(this.isNormalMode){
                this._standardMultText.visible = this.isFSMult > 0;
                this.fsMultFrame.visible = this.isFSMult > 0;

                this.resItem.texture = (this.fillerItem.texture);
                this.fillerItem.texture = (this.resTexure[0]);
            }else{
                (<PIXI.Text>this.resItem).text = (<PIXI.Text>this.fillerItem).text;
                (<PIXI.Text>this.fillerItem).text =  this.resText;
            }

            this.shuffle_tl.fromTo(this.maskCont.position,SanGameConfig.instance.REEL_ENGINE_CONFIG.DURATION.STOP/2,{y:0},{y:this.halfSymHeight, ease: Back.easeOut.config(1.7)});
            this.shuffle_tl.add(() => { 
                if(this.playBounceSound){
                    SoundManager.playSoundEffect(SoundConfig.instance.REELS_DEFAULT_BOUNCE[0]);
                    SoundManager.playSoundEffect(SoundConfig.instance.BAR_LANDING_BOUNCE);
                    if(this.playBounceSoundSlice) SoundManager.playSoundEffect(SoundConfig.instance.REVEAL_RAZOR_BOUNCE);
                } 
            },SanGameConfig.instance.REEL_ENGINE_CONFIG.DURATION.STOP/4)
            
            this.shuffle_tl.play();
        }
    }

    public setResultVal(val:string):void{
        this.resText = val == "+0" ? "X" : val;
    }

    public setResultTexture(texture:PIXI.Texture[]):void{
        this.resTexure = texture;
    }

    public prepareForExpand(sizedTexture:PIXI.Texture[],isTop:boolean):void{

        this.mask = null!;
        this.maskElement.visible = false;

        this.fillerItem.texture = (sizedTexture[0]);
        this.fillerItem.anchor.y =  isTop ? 0 : 1;
        this.resItem.anchor.y =  isTop ? 0 : 1;
        this.fillerItem.alpha = 1;
        this.fillerItem.y = isTop ? -this.halfhalfSymHeight : this.halfhalfSymHeight;
        this.resItem.y = isTop ? -this.halfhalfSymHeight : this.halfhalfSymHeight;
    }

    public resetExpand():void{
        this.boostPerformance(false);

        if(this.isNormalMode) this.fillerItem.texture = this.nextShuffleItem();

        this.fillerItem.alpha = 1;
        this.fillerItem.scale.set(1,1);
        this.resItem.scale.set(1,1);
        this.fillerItem.anchor.y = 0.5;
        this.resItem.anchor.y =  0.5;

        this.fillerItem.y = -this.halfSymHeight;
        this.resItem.y = 0;

        this.fillerItem.height = 90;
        this.resItem.height = 90;
    }

    public revealRes(durr:number):void{
        TweenLite.to(this.fillerItem, durr,{alpha:0})
    }

    public expand(value: boolean, symToReset?:PIXI.Texture[]): TimelineMax {

        let fScale: number = value ? 1 : 4;
        let tScale: number = value ? 4 : 1;

        const durrExp: number = SanGameConfig.instance.REEL_ENGINE_CONFIG.DURATION.EXPAND!;
        const easeing: number = SanGameConfig.instance.REEL_ENGINE_CONFIG.EASING.EXPAND;

        this.expand_tl = Helper.timeLineKiller(this.expand_tl, new TimelineMax({onComplete:() => {
            if(!value){
                this.resetExpand();
            }else{
                this.resItem.texture = (symToReset![0])
            }
        }}));

        this.expand_tl.add([
            TweenLite.fromTo(this.fillerItem.scale, durrExp, { y: value ? 0.25 : 1}, {
                y: value ? 1 : 0.25,
                ease: easeing
            }),
            TweenLite.fromTo(this.resItem.scale, durrExp, { y: fScale }, {
                y: tScale,
                ease: easeing
            }),
            TweenLite.fromTo(this.fillerItem, value ? durrExp * 0.5 : durrExp * 0.5, { alpha: value ? 0 : 0 }, {
                alpha: value ? 1 : 0,
                ease: Power3.easeInOut
            }),
            TweenLite.fromTo(this.resItem, value ? durrExp * 0.5 : durrExp * 0.25, { alpha: value ? 1 : 0 }, {
                alpha: value ? 0 : 1,
                ease: Power3.easeInOut
            })
        ], 0)
        
        return this.expand_tl;
    }
}

export class Revealer extends BaseView {

    private source_core_path: string = "Blocks/";

    private _state: ReavealerState = new ReavealerState(ReavealerState.NORMAL);

    private seq_bg: Sequence;
    private seq_glow: MultSequence;
    private seq_frame: Sequence;
    private animReaveal: Sequence;

    private nonWinGraphic: PIXI.Graphics;
    private fsSpecial_sp: PIXI.Sprite;
    private _standardMultText: SymbolMultiplyCounter;

    private symContainer: PIXI.Container = new PIXI.Container();
    private cont_bar: RevealerBar;

    private winSymbol: string;
    private resMysterySym: string;
    private revealedMysSym: string;

    private id: number = 0;
    private _multValue: number = 0;

    private _isActive: boolean = false;
    private _expanded: boolean = false;
    private _revealed: boolean = false;
    private _isTop: boolean = false;

    private hideAlpha: number = 0.2;

    private _loopTl: TimelineMax;
    private _animTl: TimelineMax;
    private _idleTl: TimelineMax | null;
    private _attentionTl: TimelineMax | null;

    private revSpinner:RevealSpinner;

    public get bgItem(): PIXI.DisplayObject {
        return this.seq_bg;
    }

    public get isActive(): boolean {
        return this._isActive;
    }

    public get isRevealed(): boolean {
        return this._revealed;
    }

    public set isRevealed(value:boolean){
        this._revealed = value;
        this.RePaint();
    }

    public get ID(): number {
        return this.id;
    }

    public get isExpanded(): boolean {
        return this._expanded;
    }

    public get state(): ReavealerState {
        return this._state;
    }

    public get multValue(): number {
        return this._multValue;
    }

    public get animTl():TimelineMax{
        return this._animTl ? this._animTl : new TimelineMax();
    }

    private get symChildren(): SanSpriteSymbol[] {
        return <SanSpriteSymbol[]>this.symContainer.children;
    }

    public get restShuffleTime():number{
        if(!this.revSpinner.shuffleTL || !this.revSpinner.shuffleTL.isActive()) return 0;
        return this.revSpinner.shuffleTL.duration() - this.revSpinner.shuffleTL.time();
    }

    constructor(_id: number, _isTop: boolean) {
        super();
        this._isTop = _isTop;
        this.id = _id;
        this.zIndex = 5-this.id;
        StageManager.getLayer(SanGameConfig.instance.LAYERS.FEATURE.name).addChild(this).sortChildren();
    }

    private fsSymbol:{sym:string,val:number} = {sym:"",val:0};
    public setFSSymbol(sym:string,val:number): void {
        this.fsSymbol.sym = sym == "W" ? "" : sym;
        this.fsSymbol.val = val;
    };

    protected initAnimations(): void {

        this.fillCointainer(true);
        this.addChild(this.symContainer);
        this.symContainer.alpha = 0;

        this.seq_bg = this.createSeq(GameResources.getTextures(this.source_core_path + (this._isTop ? "Block_Top" : "Block_Bottom")));
        this.seq_bg.alpha = 1;
        this.seq_bg.height = 90;

        this.revSpinner = this.addChild(new RevealSpinner());
        this.revSpinner.alpha = 0.45;

        this.revSpinner.position.y = -this.bgSizeY/2;

        this._standardMultText = this.addChild(new SymbolMultiplyCounter());
        this._standardMultText.alpha = 1;

        this._standardMultText.x = 50;

        this.cont_bar = this.addChild(new RevealerBar(this._isTop ? "Block_Top_Bars" : "Block_Bottom_Bars"));
        this.cont_bar.position.y = this._isTop ? -SanSymbolData.DEFAULT_SYMBOL.DIM.HEIGHT * 0.5 : 0;

        this.seq_glow = new MultSequence([
            "Blink_Bar_Tiny",
            "Blink_Bar_Small",
            "Blink_Bar_Medium",
            "Blink_Bar_High",
        ])
        this.seq_glow.anchor.set(0.5,0.5);
        this.seq_glow.position.y = -SanSymbolData.DEFAULT_SYMBOL.DIM.HEIGHT * 0.25;
        this.seq_glow.alpha = 0;
        this.seq_glow.blendMode = BLEND_MODES.ADD;
        this.addChild(this.seq_glow);
        
        this.seq_frame = this.createFXSeq();

        this.animReaveal =this.createSeq(GameResources.getTextures("XpandSingle"));
        this.animReaveal.alpha =1;
        this.animReaveal.scale.set(2,2);
        this.animReaveal.visible = false;

        this.fsSpecial_sp = new PIXI.Sprite(GameResources.getTextures("Blink_Splitter")[0])
        this.fsSpecial_sp.anchor.set(0.5,1);
        this.fsSpecial_sp.blendMode = BLEND_MODES.ADD;
        this.fsSpecial_sp.visible = false;
        this.addChild(this.fsSpecial_sp);
        
        this.nonWinGraphic = this.addChild(this.createGraphic());
    }

    public setSpinMode(val:boolean):void{
        if(this.revSpinner.isNormalMode === val) return;
        this.revSpinner.alpha = 0;
        this.revSpinner.spinModeNormal(val);
    }

    public showRevSpinner(val:boolean):void{
        this.revSpinner.visible = val;
    }

    protected fillCointainer(value: boolean): void {

        if (value) {
            const stepY: number = SanSymbolData.DEFAULT_SYMBOL.DIM.HEIGHT * 0.5;
            let posY: number = this._isTop ? -stepY * 0.5 : -stepY * 3.5;
            for (let i: number = 0; i < 4; i++) {
                const sym: SanSpriteSymbol = new SanSpriteSymbol(this.symChildren.length, "M1", "normal", 2);
                sym.position.y = posY;
                posY += stepY;
                this.symContainer.addChild(sym);
            }
        }
        else
            this.symChildren.forEach((c) => c.destroy());
    }

    protected changeAllContSym(symName: string): void {
        this.symChildren.forEach((s: SanSpriteSymbol) => s.changeState({
            state: ReelSymbolStates.CHANGE_SYMBOL,
            forceState: true,
            type: 2,
            newSym: symName,
            duration: 0,
        }));
    }

    public setResult(res: string, mystSym: string, isFS:boolean = false): void {

        const indx: number = this.revSpinner.shuffleArray_Res.findIndex((s) => { return res == s; })

        this.hideAlpha = isFS ? 0.35 : 0.2;
        if(!SanQuentin.api.gameClientConfiguration.showNearMissGfx){
            this.hideAlpha = 0;
        }

        this.revSpinner.setFSSymbol(0);
        this.revSpinner.playBounceSoundSlice = false;

        if (indx == -1) {
            if (SanSymbolData.isNormalSymbol(res!) || res === ReelSymbolName.WILD) {
                this._state.set(ReavealerState.NORMAL);
                if(res === this.fsSymbol.sym)
                    this.revSpinner.setFSSymbol(this.fsSymbol.val);
                this.revSpinner.setResultTexture(SanSymbolData.getTextures(res!, "normal", "2")!);
                this.winSymbol = res;
            } else {
                if(isFS && !isNaN(parseFloat(res))){
                    this.revSpinner.setResultVal("+"+res);
                    this.state.set(ReavealerState.EXTRA_FS);
                    return;
                }
                if(res == "XWAYS")
                    this.revSpinner.setResultTexture(GameResources.getTextures("M/2/M_normal"));
                else if( res == "X1")
                    this.revSpinner.setResultTexture([]);
                else
                    this.revSpinner.setResultTexture(GameResources.getTextures(this.source_core_path + this.revSpinner.shuffleArray_Res[0]));

                this.resMysterySym = mystSym == "" || mystSym == undefined ? "M" + (1 + Math.floor(Math.random() * 4)) : mystSym;
                this.winSymbol = this.resMysterySym;
                this.changeAllContSym(this.resMysterySym);

                this._state.set(ReavealerState.EXPANDING);
            }
        } else {
            this.revSpinner.setResultTexture(GameResources.getTextures("Splitter/Splitter_normal"));
            this.revSpinner.playBounceSoundSlice = true;
            this._state.set(ReavealerState.MULTIPLIER);
            this._multValue = 2;
        }
    }

    public openBar(playGlow:boolean = true): TimelineMax {
        if (this._isActive) return new TimelineMax();
        this._isActive = true;
        this.revSpinner.playBounceSound = true;
        if(playGlow){
            this.seq_glow.setTexture(GameResources.getTextures("Blink_Bar"));
            this.seq_glow.playAnimation({
                onUpdate:() => { this.seq_glow.alpha = this.seq_glow.timeline!.totalProgress() },
                onCompleteCallback: () => {
                    this.seq_glow.alpha = 1;
                    this.seq_glow.playAnimation({
                        repeat: -1,
                    })
                },
            }) 
        }
        return this.cont_bar.open();
    }

    private fsSpecTl:TimelineMax;
    public specialBarLand(type:number = 0):TimelineMax{
        this.fsSpecial_sp.texture = GameResources.getTextures(type ? "Blink_Xways" : "Blink_Splitter")[0];

        this.fsSpecTl = Helper.timeLineKiller(this.fsSpecTl,new TimelineMax({
            onStart: () => this.fsSpecial_sp.visible = true
        }),true);
        this.fsSpecTl.fromTo(this.fsSpecial_sp,1, {alpha:0.45}, {alpha: 1});
        this.fsSpecTl.play();
        return this.fsSpecTl;
    }

    public specialBarStop(duration:number = 0.45, force:boolean = false){
        this.fsSpecTl = Helper.timeLineKiller(this.fsSpecTl,new TimelineMax({
            onComplete: () => this.fsSpecial_sp.visible = false
        }),true);
        if(force) this.fsSpecial_sp.visible = false;
        this.fsSpecTl.to(this.fsSpecial_sp, duration, {alpha:0});
        this.fsSpecTl.play();
    }

    public killGlow():void{
        this.seq_glow.stop();
        const tl =  this.seq_glow.playAnimation();
        tl.to(this.seq_glow,tl.duration(),{alpha:0},0)
        tl.play();
    }

    public flashOnce():TimelineMax{
        this.seq_glow.setTexture(GameResources.getTextures("Blink_Bar"));
        const tl:TimelineMax = this.seq_glow.playAnimation({onStart: () => this.seq_glow.alpha = 1});
        tl.add(TweenLite.to(this.seq_glow,tl.duration()*0.8,{alpha:0}),"-="+tl.duration()*0.2);
        return tl;
    }

    public flashBeforeStop():TimelineMax{
        this.seq_glow.reset(true);

        const tl:TimelineMax = this.seq_glow.playAnimation();

        const timesflash:number = 1;
        const flashDurr:number = 0.5;

        const sectionDurr:number = flashDurr/timesflash;

        for(let times:number = 0; times < timesflash; times++){
            tl.add([
                TweenLite.fromTo(this.seq_glow, sectionDurr,{ alpha: 0 }, { alpha: 1 }),
                TweenLite.fromTo(this.seq_glow.scale, sectionDurr, { x: 1.3, y:1.3 }, {  x: 1, y:1 })]
            ,times*sectionDurr)
        }

        return tl;
    }

    public revealRes(playGlow:boolean = true): TimelineMax {
        if(this.isRevealed) return new TimelineMax();
        this.shuffle(false);
        
        if(playGlow){
            this.seq_glow.reset(true);
            this._loopTl.add([
                TweenLite.to(this.seq_glow, 0.25 ,{ alpha: 0 }),
                TweenLite.to(this.seq_glow.scale, 0.25, { x: 1.3, y:1.3 })
            ],0)
            this._loopTl.add(() => this.seq_glow.scale.set(1,1))
        }

        return this._loopTl;
    }

    public expandRes(active: boolean, delayReveal: number = 0, ovrrFade:number = -1): TimelineMax {
        this._animTl = Helper.timeLineKiller(this._animTl, new TimelineMax());
        if(this.isRevealed == active) return this._animTl;

        if (this._state.equal(ReavealerState.EXPANDING)) {
            const fadeDurr: number = ovrrFade >= 0 ? ovrrFade : (active ? 0.35 : 0.15);
            const toAlpha: number = active ? 1 : 0;
            const fromAlpha: number = active ? 0 : 1;
            
            this.isRevealed = active;

            if(this.resMysterySym == this.fsSymbol.sym)
                this.symChildren.forEach(s => s.isFSMarked(this.fsSymbol.val));
            else
                this.symChildren.forEach(s => s.isFSMarked(0));
            
            this._animTl.add([
                () => {if(active) SoundManager.playSoundEffect(SoundConfig.instance.XWAY_REVEAL_SINGLE)},
                TweenLite.to(this.symContainer, fadeDurr, { alpha: toAlpha }),
                TweenLite.to(this.seq_bg, fadeDurr, { alpha: fromAlpha }),
            ], 0);

            if (active) {
                this._animTl.add([
                    this.animReaveal.playAnimation({onStart:() => this.animReaveal.visible = true, onCompleteCallback:() => this.animReaveal.visible = false}),
                    () => this.revSpinner.revealRes(fadeDurr),
                ], delayReveal);
            } else {
                this.animReaveal.visible = false;
                this._animTl.add(this.expand(active), 0);
            }
        }

        if (!active) {
            this._animTl.add([
                () => this.symChildren.forEach((s: SanSpriteSymbol) => s.hideMult()),
            ], 0);
        }

        return this._animTl;
    }

    public setBounceSound(val:boolean){
        this.revSpinner.playBounceSound = val;
    }

    public closeBar(): TimelineLite {
        if (!this._isActive) return new TimelineMax();
        this._isActive = false;
        this.revSpinner.playBounceSound = false;
        const tl: TimelineLite = new TimelineLite();
        if (this._expanded && this._state.equal(ReavealerState.EXPANDING)) {
            tl.add([
                this.expand(false),
                TweenLite.to(this.symContainer, 0.15, { alpha: 0 }),
                TweenLite.to(this.seq_bg, 0.15, { alpha: 1 })
            ]);
        }

        tl.add([
            () => this.cont_bar.close(),
            TweenLite.to(this.revSpinner, 0.25, { alpha: this.hideAlpha }),
            () => this.symChildren.forEach((s: SanSpriteSymbol) => s.hideMult()),
        ]);

        if (this.seq_glow.timeline && this.seq_glow.timeline?.isActive()) {
            this.seq_glow.reset(true);
            this.seq_glow.playAnimation().to(this.seq_glow, 0.3, { alpha: 0 });
        }

        tl.play();
        return tl;
    }

    public shuffle(active: boolean,forceHide?:boolean): TimelineMax {
        this._loopTl = this.revSpinner.shuffle(active);
        if (!active)  TweenLite.to(this.revSpinner, SanGameConfig.instance.REEL_ENGINE_CONFIG.DURATION.STOP,{ alpha: this.isActive ? (forceHide ? 0 : 1) : this.hideAlpha })
        return this._loopTl;
    }

    public expand(value: boolean): TimelineMax {
        if (!this._state.equal(ReavealerState.EXPANDING) || this._expanded == value || !this.isActive) return new TimelineMax();

        this._expanded = value;

        const durrExp: number = SanGameConfig.instance.REEL_ENGINE_CONFIG.DURATION.EXPAND!;
        const easeing: number = SanGameConfig.instance.REEL_ENGINE_CONFIG.EASING.EXPAND;

        if(value){
            this.seq_frame.setTexture(GameResources.getTextures("X_Ways_Landing"));
            this.seq_frame.blendMode = BLEND_MODES.ADD;
            this.seq_frame.position.y = this._isTop ? SanSymbolData.DEFAULT_SYMBOL.DIM.HEIGHT * 0.5 : -SanSymbolData.DEFAULT_SYMBOL.DIM.HEIGHT;

            if(this.winSymbol == "W")
                this.revSpinner.prepareForExpand(GameResources.getTextures(this._isTop ? "M/7/M_normal_top" : "M/7/M_normal_bottom"),this._isTop);
            else {
                this.revSpinner.prepareForExpand(GameResources.getTextures("M/7/M_normal"),this._isTop);
            }

            this.changeAllContSym(this.resMysterySym);
            this.revealedMysSym = this.resMysterySym;
        }
        
        const tl:TimelineMax = this.revSpinner.expand(value, SanSymbolData.getTextures(this.revealedMysSym, "normal", "2"));
        SanEngineManager.onExpandSymbol({
            shrink: value,
            targetSym: this._isTop ? 2 : 0,
            reelID: [this.id],
            type: value ? 2 : 4,
            duration: durrExp
        });
        if(value){
            this.symContainer.position.y = 0;
        }else{
            tl.add([
                TweenLite.to(this.symContainer.position, durrExp, {
                    y: this._isTop ? -SanSymbolData.DEFAULT_SYMBOL.DIM.HEIGHT*.25 : SanSymbolData.DEFAULT_SYMBOL.DIM.HEIGHT*.25,
                    ease: easeing
                }),
            ],0)
        }
        
        tl.add([
            TweenLite.fromTo(this.symContainer.scale, durrExp, { y: !value ? 1 : 1 }, {
                y: !value ? 0.25 : 1,
                ease: easeing
            }),
            TweenLite.fromTo(this.cont_bar.scale, durrExp, { y: 0.25 }, {
                y: 1,
                ease: easeing
            }),
        ],0)

        if(value)
            tl.add(this.seq_frame.playAnimation({onStart:() => this.seq_frame.alpha = 1 , onCompleteCallback:() => this.seq_frame.alpha = 0}),"-=" + durrExp*0.25)
        
        return tl;
    }

    private winAnimTl:TimelineMax;
    public winAnimation(duration: number = 0.5,lvl:number): TimelineMax {
        this.winAnimTl = Helper.timeLineKiller(this.winAnimTl, new TimelineMax(), true);
        return this.playWin(this.winAnimTl,duration,0,undefined,lvl);
    }

    hintValue(val:number,ways:number) {
        ReelOverlay.instance.playValueText(this,val,ways);
    }
    
    public glowBiggy(duration:number,lvl:number):TimelineMax | TimelineMax[]{
        this.seq_glow.stop();

        if (this._state.equal(ReavealerState.EXPANDING)){
            const tls:TimelineMax[] = [];
            for (let i: number = 0; i < this.symChildren.length; i++) tls.push(this.symChildren[i].glowBiggy(duration,lvl));
            return tls;
        }
        return this.seq_glow!.play({
            duration: duration,
            onUpdate:() => this.seq_glow!.alpha = 1 - this.seq_glow!.timeline!.totalProgress()*0.6,
            onCompleteCallback: () => this.glowLoop(duration)
        },lvl);
    }

    private glowLoop(duration:number):TimelineMax{
        return this.seq_glow!.play({
            duration: duration,
            onUpdate: () => {
                const nt:number = this.seq_glow!.timeline!.progress();
                if (nt > .5) {
                    this.seq_glow!.alpha = 0.4 + (nt * 0.6) * 2;
                } else
                    this.seq_glow!.alpha = 1 - ((nt - 0.5) * 2) * 0.6;
            },
            onCompleteCallback:() => this.glowLoop(duration)
        })
    }

    public glow(duration:number,lvl:number):TimelineMax | TimelineMax[]{
        if (this._state.equal(ReavealerState.EXPANDING)){
            const tls:TimelineMax[] = [];
            for (let i: number = 0; i < this.symChildren.length; i++) tls.push(this.symChildren[i].glow(duration,lvl));
            return tls;
        }
        this.seq_glow.stop();
        return this.seq_glow!.play({ 
            duration: duration,
            onUpdate:() => this.seq_glow!.alpha = 1 - this.seq_glow!.timeline!.totalProgress()
        },lvl);
    }

    public glowMult():TimelineMax | TimelineMax[]{
        this.seq_glow.setTexture(GameResources.getTextures("Blink_Bar"));
        const tl:TimelineMax = this.seq_glow.playAnimation({onStart: () => this.seq_glow.alpha = 1,duration:0.25});
        tl.add(TweenLite.to(this.seq_glow,0.35*0.8,{alpha:0}),"-="+tl.duration()*0.2);
        return tl;
    }

    public idleWinAnimation(duration: number = 0.5,lvl:number): TimelineMax {
        if (!this._idleTl) this._idleTl = Helper.timeLineKiller(this._idleTl!, new TimelineMax(), true);
        return this.playWin(this._idleTl,duration,this._idleTl.totalTime(),ReelSymbolStates.IDLE,lvl);
    }

    public setInteractive(val:boolean):void{
        if(!this.isActive) return;

        if(this._expanded)
            this.symChildren.forEach(s => s.setInteractive(val))
        else if(this._state.equal(ReavealerState.NORMAL))
        {
            if(val)
                this.revSpinner.on('pointerdown', () => this.sendToMiniTable());
            else
                this.revSpinner.off('pointerdown', () => this.sendToMiniTable());
            this.revSpinner.interactive = val;
        }
    }

    private sendToMiniTable():void{
        EventHandler.dispatchEvent(new GameEvent(PayTableEvent.CLICK, {dispObj:this.revSpinner.resSeq, name:this.winSymbol} ));
    }

    private playWin(tl:TimelineMax,duration:number, startpos:number, state:string = ReelSymbolStates.WIN,lvl:number):TimelineMax {

        if (this._state.equal(ReavealerState.EXPANDING)) {
            for (let i: number = 0; i < this.symChildren.length; i++) {
                this.symChildren[i].changeState({ state: state, duration: duration, type:lvl });
                tl.to(this,duration,{},startpos);
            }
        }
        else {

            if(ReelSymbolStates.IDLE == state){
                const texturePath:string = state === ReelSymbolStates.WIN ? "Frame_Win_2" : "Frame_Toggle_2";
                this.seq_frame.setTexture(GameResources.getTextures(texturePath));
                this.seq_frame.blendMode = BLEND_MODES.NORMAL;
                this.seq_frame.position.y = -SanSymbolData.DEFAULT_SYMBOL.DIM.HEIGHT * 0.25;
                this.seq_frame.stop(true);
            }
            
            this.seq_glow.setLvl(lvl)
            tl.to(this.seq_glow, duration/2,{alpha:1}, startpos);
            tl.to(this.seq_glow, duration/2,{delay:duration/2,alpha:0}, startpos);
            if(ReelSymbolStates.IDLE == state){
                tl.add(() => this.seq_frame.playAnimation({
                    onStart:() => this.seq_frame.alpha = 1,
                    onCompleteCallback:() => this.seq_frame.alpha = 0
                }), startpos);
            }
        }
        return tl;
    }

    public resetIdleTimeline(): void {
        if (this._idleTl) this._idleTl.totalProgress(1);
        this._idleTl = Helper.timeLineNuller(this._idleTl);
    }

    public defineSplit():TimelineMax{

        const reelSym: SanSpriteSymbol[] = <SanSpriteSymbol[]>SanEngineManager.getReel(this.id).AllWindowSymbols;
        const tl: TimelineMax = new TimelineMax();

        let index: number = this._isTop ? 0 : reelSym.length - 1;
        for (let k: number = 0; k < reelSym.length; k++) {
            if(!reelSym[index].isJumpWild){
                tl.add(reelSym[index].defineSplit(this._multValue), k * 0.15);
                tl.add(() => SoundManager.playSoundEffect(SoundConfig.instance.WILD_SPLIT), k * 0.15);
            }
            index += this._isTop ? 1 : -1;
        }
        
        return tl;
    }

    public onResize(): void {
        const reelScaledY: number = SanEngineManager.dim.scale.y;
        const scaledHeight: number = SanSymbolData.DEFAULT_SYMBOL.DIM.HEIGHT * reelScaledY;

        if (this._isTop)
            this.position = MathHelper.pointSub(SanEngineManager.getReelPos(this.id), new PIXI.Point(0, -1 + scaledHeight * 0.5 - (this.pivot.y * reelScaledY)));
        else
            this.position = MathHelper.pointAdd(SanEngineManager.getReelPos(this.id), new PIXI.Point(0, scaledHeight * 3));
        
        this.symChildren.forEach(sym => sym.onResize());
        this.scale = SanEngineManager.dim.scale;

        this.RePaint();
    }

    public attentionDarkness(alphaValue:number = 0.6, duration:number = 0.2,force?:boolean):TimelineMax {
        this._attentionTl = Helper.timeLineKiller(this._attentionTl!, new TimelineMax());

        if(!force && this._state.equal(ReavealerState.MULTIPLIER) && this.isActive){
            return this._attentionTl;
        }

        const toAlpha = alphaValue;
        this.RePaint();
        this._attentionTl.to(this.nonWinGraphic , duration, {alpha: toAlpha });
        return this._attentionTl;
    }

    private get barSeqPosY():number{
        return this._isTop ? -SanSymbolData.DEFAULT_SYMBOL.DIM.HEIGHT * 0.5 : 0;
    }

    private createFXSeq(texture?: PIXI.Texture[]): Sequence {
        const seq: Sequence = Sequence.createSequence(texture);
        seq.anchor.set(0.5,0.5);
        seq.position.y = -SanSymbolData.DEFAULT_SYMBOL.DIM.HEIGHT * 0.25;
        seq.alpha = 0;
        this.addChild(seq);
        return seq;
    }

    private createSeq(texture?: PIXI.Texture[]): Sequence {
        const seq: Sequence = Sequence.createSequence(texture);
        seq.position.y = this.barSeqPosY;
        seq.anchor.set(0.5, this._isTop ? 0 : 1);
        seq.alpha = 0;
        this.addChild(seq);
        return seq;
    }

    private get bgSizeY():number{
        return Math.round(this.seq_bg.height);
    }
    
    private createGraphic():PIXI.Graphics{
        const graphicBg:PIXI.Graphics =  new PIXI.Graphics();
        graphicBg.beginFill(0x000000, 1);
        graphicBg.drawRect(-SanSymbolData.DEFAULT_SYMBOL.DIM.WIDTH/2, -this.bgSizeY/2,
             SanSymbolData.DEFAULT_SYMBOL.DIM.WIDTH, this.bgSizeY);
        graphicBg.endFill();
        graphicBg.alpha = 0;
        return graphicBg;
    }

    private RePaint():void{
        const w:number = SanSymbolData.DEFAULT_SYMBOL.DIM.WIDTH;
        const h:number = this.isExpanded ? this.bgSizeY*4 : this.bgSizeY;
        const hPos:number = this.isExpanded ? h*0.75 : 0;
        this.nonWinGraphic.clear();
        this.nonWinGraphic.beginFill(0x000000, 1);
        this.nonWinGraphic.drawRect(-w/2, -h + (this._isTop ? hPos : 0),
            w, h);
       this.nonWinGraphic.endFill();
    }
}